import type { ICellEditorParams } from "ag-grid-community";
import { type FC, forwardRef } from "react";
import { Icon, Icons } from "widgets";

import { getCssColor } from "@/app-utils/color.ts";
import type { Sample } from "@/graphql.js";
import { TileStatus } from "@/modules/core/components/settings.ts";
import { Tile } from "@/modules/core/components/Tile.tsx";
import { ENTITY_TYPE, FEATURE_DISPLAY_NAME } from "@/settings/settings.js";

interface SampleTileProps {
  sample: Sample;
}

const SampleTile = forwardRef<HTMLDivElement, SampleTileProps>(function SampleTile(props, ref) {
  const sample: Sample = props.sample;

  return (
    <Tile
      title={sample.name}
      icon={<img src={Icons.Tiles.Sample} width={24} height={30} />}
      type={sample.type?.name}
      statusDisplayName={FEATURE_DISPLAY_NAME[ENTITY_TYPE.SAMPLE]}
      dates={{
        created: sample.created,
        modified: sample.modified,
      }}
      project={sample.project}
      to={`/${ENTITY_TYPE.SAMPLE}/${sample.id}`}
      protectionStatus={
        sample.deleted ? TileStatus.Deleted : sample.hidden ? TileStatus.RestrictedVisibility : TileStatus.Normal
      }
      coloredLabel={[
        { color: sample.status?.color ? getCssColor(sample.status?.color) : undefined, label: sample.status?.name },
      ]}
      ref={ref}
      titleTrailer={sample.locked ? <SampleLockedIcon size={15} /> : null}
    >
      {sample.description}
    </Tile>
  );
});

interface SampleLockedIconProps {
  size: number;
}

const SampleLockedIcon: FC<SampleLockedIconProps> = (props) => {
  return <Icon icon={"lock"} style={{ fontSize: props.size, width: props.size, height: props.size }} />;
};

export { SampleLockedIcon, SampleTile };
